/* ============================================================================
   Columnas con imagen · carrusel en móvil (puntos indicadores)
   ----------------------------------------------------------------------------
   El deslizamiento lo hace el CSS (scroll-snap, assets/hp-product-sections.css);
   este script solo sincroniza los puntos con la foto visible y permite saltar
   a una foto tocando su punto. Lo carga sections/text-columns-with-images.liquid
   cuando el ajuste «Carrusel en móvil» está activo.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__hpTextColumnsCarousel) return;
  window.__hpTextColumnsCarousel = true;

  function slides(track) {
    return Array.prototype.filter.call(track.children, function (el) {
      return el.classList.contains('text-column');
    });
  }

  function activeIndex(track) {
    var items = slides(track);
    var start = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
    var best = 0;
    var bestDistance = Infinity;
    items.forEach(function (item, i) {
      var distance = Math.abs(item.getBoundingClientRect().left - start);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = i;
      }
    });
    return best;
  }

  function paint(dots, index) {
    Array.prototype.forEach.call(dots.children, function (dot, i) {
      var on = i === index;
      dot.classList.toggle('is-active', on);
      if (on) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function init(section) {
    var track = section.querySelector('[data-hp-tc-track]');
    var dots = section.querySelector('[data-hp-tc-dots]');
    if (!track || !dots || track.__hpTcInit) return;
    track.__hpTcInit = true;

    var frame = null;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        paint(dots, activeIndex(track));
      });
    }, { passive: true });

    dots.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-index]');
      if (!dot) return;
      var item = slides(track)[Number(dot.getAttribute('data-index'))];
      if (!item) return;
      var offset = item.getBoundingClientRect().left - track.getBoundingClientRect().left -
        parseFloat(getComputedStyle(track).paddingLeft || 0);
      track.scrollBy({ left: offset, behavior: 'smooth' });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.section-text-columns-with-images'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
